import { HttpClient } from '@angular/common/http';

import { Injectable, Inject } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { Serializer } from '../../../helpers/serializer/seriealizer';
import { AccountCancelEnum } from '../../../services/api-names';
import { SessionService } from '../../../services/session.service';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { Utils } from '../../../utils/utils';
import { CancelRequestInterface } from '../request/interfaces/cancel-request.interface';
import { CancelResponseInterface } from '../response/interfaces/cancel-response.interface';
import { CancelResponseModel } from '../response/models/cancel-response.model';

@Injectable({
  providedIn: 'root',
})
export class AccountCloseService {
  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private httpClient: HttpClient,
    private serializer: Serializer,
    private session: SessionService
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.clientCode = this.session.clientCode;
  }

  cancelRequest(
    portfolioCode: string,
    cancelData: CancelRequestInterface
  ): Observable<CancelResponseInterface> {
    //this.updateSession();

    const body = this.serializer.toJson(cancelData);

    const url =
      this.config.baseApi +
      Utils.formatString(
        AccountCancelEnum.apirest_accountcancel_cancelrequest,
        [portfolioCode]
      );

    return new Observable((observer: Observer<CancelResponseInterface>) => {
      this.httpClient
        .post(url, body)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, CancelResponseModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  otpRequest(
    portfolioCode: string,
    verificationId: string
  ): Observable<CancelResponseInterface> {
    //this.updateSession();

    const body = {};

    const url =
      this.config.baseApi +
      Utils.formatString(AccountCancelEnum.apirest_accountcancel_otp, [
        portfolioCode,
        verificationId,
      ]);

    return new Observable((observer: Observer<CancelResponseInterface>) => {
      this.httpClient
        .post(url, body)
        .pipe(
          map((resp: any) => {
            const t = this.serializer.fromJson(resp, CancelResponseModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }

  validationRequest(
    portfolioCode: string,
    verificationId: string,
    code: string
  ): Observable<CancelResponseInterface> {
    //this.updateSession();

    this.config.smsCode = code;

    const body = {};

    const url =
      this.config.baseApi +
      Utils.formatString(AccountCancelEnum.apirest_accountcancel_verification, [
        portfolioCode,
        verificationId,
      ]);

    return new Observable((observer: Observer<CancelResponseInterface>) => {
      this.httpClient
        .post(url, body)
        .pipe(
          map((resp: any) => {
            this.config.smsCode = '';
            const t = this.serializer.fromJson(resp, CancelResponseModel);
            return t;
          })
        )
        .subscribe(
          (resp: any) => {
            observer.next(resp);
            observer.complete();
          },
          (err) => observer.error(err)
        );
    });
  }
}
